import { 
    Column, 
    CreateDateColumn, 
    Entity, 
    PrimaryGeneratedColumn, 
    UpdateDateColumn, 
    VersionColumn 
} from "typeorm";

@Entity('employee_training_entity')
export class EmployeeTrainingEntity {
    @PrimaryGeneratedColumn("increment", { name: 'training_id' })
    trainingId: number;

    @Column("varchar", {
        nullable: false,
        name: "training_title",
        length: 50
    })
    trainingTitle: string;


    @Column("varchar", {
        nullable: true,
        name: "date_of_training",
        length: 50
    })
    dateOfTraining: string;

    @Column("varchar", {
        nullable: true,
        name: "faculty",
        length: 50
    })
    faculty: string;

    @Column("varchar", {
        nullable: true,
        name: "duration",
        length: 50
    })
    duration: string;

    @Column("varchar", {
        nullable: true,
        name: "topic_covered",
        length: 250
    })
    topicCovered: string;

    @Column("varchar", {
        nullable: true,
        name: "employee_code",
        length: 50
    })
    employeeCode: string;

    @Column("varchar", {
        nullable: true,
        name: "employee_name",
        length: 50
    })
    employeeName: string;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'plant'
    })
    plant: string;

}